module.exports = __webpack_public_path__ + "media/food.33947315.mp4";